import * as yup from 'yup';
import { Entity } from './types';
import { filter, find, isEmpty, propEq } from 'ramda';

export const defaultValueForConnectionForm = {
  accountFormat: '',
  host: '',
  apiPrefix: '',
  user: '',
  apikey: '',
  employerId: []
};
export const connectionGridSchema = yup.object({
  accountFormat: yup.string(),
  host: yup.string(),
  apiPrefix: yup.string(),
  user: yup.string(),
  apikey: yup.string(),
  employerId: yup.array().of(yup.number()).nullable()
});

export const generalSchema = yup.object({
  import_employee_type: yup.string(),
  import_employee_startDate: yup.date(),
  import_employee_createMissingContext: yup.boolean()
});

export const createKeyValueObject = (
  propertyMappings?: Entity['propertyMappings']
): Record<string, string> => {
  const keyValueObject: Record<string, string> = {};

  if (!isEmpty(propertyMappings))
    propertyMappings?.forEach(({ internalName, externalName }) => {
      keyValueObject[internalName] = externalName;
    });

  return keyValueObject;
};
export const additionalSettingsSchema = yup.object({
  entityMapping: yup.number().required()
});

export const createEntityFromKeyValueObject = (
  keyValueObject: Record<string, string>
) => {
  return Object.entries(keyValueObject).map(([internalName, externalName]) => ({
    internalName,
    externalName
  }));
};

export const connectorSchema = yup.object({
  benefits: yup.string(),
  addresschanges: yup.string(),
  absences: yup.string(),
  salaries: yup.string(),
  travelarrangements: yup.string(),
  employees: yup.string(),
  hourmanagement: yup.string()
});

export const convertDefaultValue = (mainArray: any[], propArray: any[]) => {
  return filter((mainItem) => {
    const propItem = find(propEq('employerId', mainItem.employerId), propArray);
    return propItem !== undefined;
  }, mainArray);
};
